import { styled } from "../../styled-components";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;

    height: 100%;
    align-items: stretch;
    padding-top: ${p => p.theme.navBar.height}px;
`;

export const OverlayScroller = styled.div`
    overflow-y: auto;
    overflow-x: hidden;

    ::-webkit-scrollbar {
        display: none;
    }

    flex-shrink: 1;

    padding: 5px 30px 0px 30px;
`;
